import type { ICheckOTPResponse, ISendOTPResponse } from "../typings";
import { useTransport } from "../composables/useTransport";
import useDirectFetch from "../composables/useDirectFetch";
import { urls } from "./config";

const getCheckCodeParams = (
  aud: string,
  code: string,
  phone: string,
  attemptId: string,
  options = {},
) => ({
  gateway: "magnit-id" as const,
  method: "POST" as const,
  body: {
    aud,
    code,
    phone,
    attemptId,
  },
  ...options,
});
export const requestCheckCode = (
  aud: string,
  code: string,
  phone: string,
  attemptId: string,
  options = {},
) => {
  return useTransport<ICheckOTPResponse>(urls.otp.checkCode, getCheckCodeParams(aud, code, phone, attemptId, options));
};
export const fetchCheckCode = (
  aud: string,
  code: string,
  phone: string,
  attemptId: string,
  options = {},
) => {
  return useDirectFetch<ICheckOTPResponse>(urls.otp.checkCode, getCheckCodeParams(aud, code, phone, attemptId, options));
};

const getCodeParams = (aud: string, captchaToken: string, phone: string, options = {}) => ({
  gateway: "magnit-id" as const,
  method: "POST" as const,
  body: {
    aud,
    "captcha-token": captchaToken,
    phone,
  },
  ...options,
});
export const requestCode = (aud: string, captchaToken: string, phone: string, options = {}) => {
  return useTransport<ISendOTPResponse>(urls.otp.getCode, getCodeParams(aud, captchaToken, phone, options));
};
export const fetchCode = (aud: string, captchaToken: string, phone: string, options = {}) => {
  return useDirectFetch<ISendOTPResponse>(urls.otp.getCode, getCodeParams(aud, captchaToken, phone, options));
};
